export default __webpack_public_path__ + "static/media/chat.b9d8614c.svg";